import { CacheConfig } from '../base/define';

const config: CacheConfig = {
  'get-wechat-sign': {
    url: '/api/steam/wechat/jsConfig',
    method: 'get',
  },
  'get-nos-token': {
    url: '/api/steam/nos/getToken',
    method: 'post',
  },
  'get-nos-token-safe': {
    url: '/api/steam/nos/getTermsToken',
    method: 'post',
  },
  'get-share-nos-token': {
    url: '/api/steam/common/course/clock/getNosToken',
    method: 'post',
  },
  'get-yx-sign': {
    url: '/api/admin/steam/vcloud/initUpload',
    method: 'get',
  },
  'get-user-group-info': {
    url: '/api/steam/admin/user/getUserGroupInfo',
    method: 'get',
  },
};
export default config;
